import { ReactNode } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import { appendTestableComponentAttributes, TestableComponentProps } from '@dreryk/react-components';

import { StyledPrescriptionListHeader } from './PrescriptionListHeader.styled';
import { StyledPrescriptionListHeaderHeading } from './PrescriptionListHeaderHeading.styled';

type PrescriptionListHeaderProps = TestableComponentProps & {
   readonly label: TranslatableText;
   readonly children?: ReactNode;
};

export const PrescriptionListHeader = (props: PrescriptionListHeaderProps): JSX.Element => {
   const { children, testId, label } = props;

   return (
      <StyledPrescriptionListHeader {...appendTestableComponentAttributes('PrescriptionListHeader', testId)}>
         <StyledPrescriptionListHeaderHeading
            content={label}
            type={'h2'}
            testId={'prescriptionListHeading'}
            margin={'0px'}
         />
         {children}
      </StyledPrescriptionListHeader>
   );
};
